import { ComingSoonPage } from '@todo/web-ui/components/coming-soon-page';

export default function SavedPage() {
  return <ComingSoonPage page="saved" />;
}
